import { Col, Button, Row } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import React from 'react'
import * as styles from './contributeAsUserButtons.css'
import {
  getGroupDetailPageVariant,
  tracking,
} from '../../../lib/analytics/fpti'
import Events from '../../../lib/analytics/eventTags.js'
import serverData from '../../../utils/server-data'

interface Props {
  isAdmin: boolean
  hasFunds: boolean
  isActiveGroup: boolean
  transferUrl: string
  handleContributeAsUser: () => void
  isSmallerScreen: boolean
  groupId: string
}
export const ContributeAsUserButtons = ({
  isAdmin,
  hasFunds,
  isActiveGroup,
  transferUrl,
  handleContributeAsUser,
  isSmallerScreen,
  groupId,
}: Props) => {
  const handleClickOnContributeAsUser = () => {
    tracking(
      Events.p2p_pools_detail_contribute_pressed({
        source: serverData.trackingParameters.externalSource,
        page_variant: getGroupDetailPageVariant(isAdmin, true),
        pool_id: groupId,
      }),
    )
    handleContributeAsUser()
  }

  const displayTransferButton = isAdmin && hasFunds

  if ((!displayTransferButton && !isActiveGroup) || isSmallerScreen) {
    return null
  }

  return (
    <Row>
      {displayTransferButton && (
        <Col xs={isActiveGroup ? 6 : 12}>
          <Button
            variant="secondary"
            className={styles.buttonContributeUser}
            as="a"
            href={transferUrl}
            role="button"
            data-testid="transferButton"
          >
            <Message id="flatProgress.transfer" />
          </Button>
        </Col>
      )}
      {isActiveGroup && (
        <Col xs={displayTransferButton ? 6 : 12}>
          <Button
            className={styles.buttonContributeUser}
            onClick={handleClickOnContributeAsUser}
            role="button"
            data-testid="contributeAsUserButton"
          >
            <Message id="flatProgress.contribute" />
          </Button>
        </Col>
      )}
    </Row>
  )
}
